import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading, Text, Link as ExternalLink } from '@pancakeswap/uikit'
import { Progman21 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'

const HowToBuyModal = ({ close, modalStyle, frameStyle, bulletStyle }) => {
  const { t } = useTranslation()

  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<Progman21 />}
      title="How to Buy"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`How to Buy`)}
        </Heading>

        <Text fontSize="18px">{t(`Follow these steps to buy and hold Windoge95 V2:`)}</Text>
        <ul>
          <ExternalLink
            external
            style={{ color: '#000088' }}
            href="https://metamask.io/"
            target="_blank"
            rel="noreferrer"
          >
            <li style={{ ...bulletStyle, marginBottom: '0px' }}>{t(`Install MetaMask, or use an existing wallet`)}</li>
          </ExternalLink>
          <li style={bulletStyle}>{t(`Open the WindogeSwap tool and connect your wallet.`)}</li>
          <li style={bulletStyle}>{t(`Adjust your slippage settings to 12%`)}</li>
          <li style={bulletStyle}>{t(`Submit and confirm the transaction!`)}</li>
        </ul>
      </Frame>
    </Modal>
  )
}

export default HowToBuyModal
